module.exports = __webpack_public_path__ + "static/img/arrow.89940a59.svg";